import { Button, Tooltip } from '@sparemin/blockhead';
import React from 'react';
import { H1 } from 'components/Heading';
import LinkButton from 'components/LinkButton';
import List from 'components/List';
import ScrollBars from 'components/ScrollBars';
import { VideoTypeConfig } from './types';
import { block } from './utils';

export interface DestinationPlatformsVideoTypesProps {
  title?: React.ReactNode;
  icon: React.ReactNode;
  videoTypes: VideoTypeConfig[];
  onClick: (videoType: VideoTypeConfig) => void;
  onBackClick?: () => void;
  listHeight?: number;
}

const DestinationPlatformsVideoTypes = ({
  title = 'Choose a video type',
  icon,
  videoTypes,
  onClick,
  onBackClick,
  listHeight,
}: DestinationPlatformsVideoTypesProps) => {
  return (
    <div className={block('video-types')}>
      <div className={block('main-icon')}>{icon}</div>

      <H1 className={block('title')}>{title}</H1>

      <LinkButton
        onClick={onBackClick}
        className={block('choose-another-button')}
        size="md"
        theme="cta"
        uppercase
      >
        ← choose another destination
      </LinkButton>

      <List>
        <ScrollBars autoHeight autoHeightMax={listHeight ?? 340}>
          {videoTypes.map(config => {
            return (
              <List.Item
                key={config.id}
                className={block('video-type-row')}
                modifiers={['no-padding']}
              >
                <Tooltip
                  arrow
                  isDisabled={!config.disabledTooltip}
                  contents={config.disabledTooltip}
                  placement="top"
                  strategy="fixed"
                >
                  <Button
                    {...config.metadata}
                    className={block('video-type-component')}
                    isDisabled={config.disabled}
                    onPress={() => onClick(config)}
                  >
                    <List.Item.Contents>
                      <List.Item.Artwork>
                        <div className={block('icon-container')}>
                          {config.icon}
                        </div>
                      </List.Item.Artwork>

                      <List.Item.Text
                        className={block('text')}
                        primary={config.title}
                        secondary={
                          <span className={block('desc')}>
                            {config.description}
                          </span>
                        }
                      />
                    </List.Item.Contents>
                  </Button>
                </Tooltip>
              </List.Item>
            );
          })}
        </ScrollBars>
      </List>
    </div>
  );
};

export default DestinationPlatformsVideoTypes;
